import React, { useState, useEffect } from 'react';

const KEY = 'cookie_consent';

// Lightweight cookie-consent banner. Records the choice in localStorage so it
// only shows once. Analytics/marketing scripts should check this value
// (localStorage 'cookie_consent') before loading.
export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try { if (!localStorage.getItem(KEY)) setVisible(true); } catch { /* ignore */ }
  }, []);

  const choose = (choice) => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ choice, at: new Date().toISOString() }));
    } catch { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[80] bg-gray-900 text-gray-100 px-4 py-4 shadow-2xl">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row md:items-center gap-3">
        <p className="text-sm flex-1 leading-snug">
          Sitenin çalışması için zorunlu çerezler kullanıyoruz; analiz ve pazarlama çerezleri yalnızca onayınızla çalışır.{' '}
          <a href="/yasal/cerez-politikasi" className="underline text-blue-300 hover:text-blue-200">Çerez Politikası</a>
        </p>
        <div className="flex gap-2 shrink-0">
          <button onClick={() => choose('rejected')}
            className="text-sm border border-gray-500 text-gray-200 px-4 py-2 rounded-lg hover:bg-gray-800 transition">Reddet</button>
          <a href="/yasal/cerez-politikasi"
            className="text-sm border border-gray-500 text-gray-200 px-4 py-2 rounded-lg hover:bg-gray-800 transition">Tercihleri Yönet</a>
          <button onClick={() => choose('accepted')}
            className="text-sm bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded-lg transition">Kabul Et</button>
        </div>
      </div>
    </div>
  );
}
